import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectPermissionAllowed,
  selectPermissionsReady,
} from "@/features/permissions/permissionsSlice";
import { isFrontendRbacDisabled } from "@/utils/rbacToggle";
import {
  getEffectiveUser,
  shouldBypassPermissionMatrix,
} from "@/utils/permissionsUser";

/**
 * @param {string|null|undefined} code - permission_pages.code
 * @param {'view'|'create'|'edit'|'delete'} [action]
 */
export function usePagePermission(code, action = "view") {
  const rbacDisabled = isFrontendRbacDisabled();
  const permissionsBypass = useSelector((s) => s.permissions.bypass);
  const authUser = useSelector((s) => s.auth.user);
  const matrixBypass = useMemo(
    () => shouldBypassPermissionMatrix(getEffectiveUser(authUser)),
    [authUser]
  );
  const skipMatrix = rbacDisabled || permissionsBypass || matrixBypass;

  const ready = useSelector(selectPermissionsReady);
  const allowed = useSelector((state) =>
    code ? selectPermissionAllowed(state, code, action) : true
  );

  return useMemo(
    () => ({
      allowed: skipMatrix ? true : !!allowed,
      ready: skipMatrix ? true : ready,
    }),
    [skipMatrix, allowed, ready]
  );
}
